import { useCallback, useContext, useSyncExternalStore } from 'react';
import { DragPreviewContext } from './DragPreviewContext';
export default function useDragPreviewManagerValue(selector) {
  const {
    dragPreviewManager
  } = useContext(DragPreviewContext);
  if (!dragPreviewManager) {
    throw new Error('DragPreviewManager not initialized');
  }
  const subscribe = useCallback(cb => {
    return dragPreviewManager.subscribe(cb);
  }, [dragPreviewManager]);
  const cb = useCallback(() => {
    return selector(dragPreviewManager);
  }, [selector, dragPreviewManager]);
  return useSyncExternalStore(subscribe, cb);
}